module.exports = __webpack_public_path__ + "img/HiddenExit-Blue.95381af9.png";